import React from 'react'

import { Field } from 'formik'

import { Form, Row, Col } from '_zari/core'

import ModalidadCalculosDeDepreciacionConstant from 'constants/modalidadDeCalculoDeDepreciacion'

const ModalidadCalculoDeDepreciacionFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Form.Label
        text='MODALIDAD'
        htmlFor='checkbox-modalidadCalculoDeDepreciacion'
        md={4}
        alignRightAt='md'
      />
      <Col md={8} className='col-modalidadCalculoDeDepreciacion'>
        <Row>
          <Col md={12}>
            <Field name='modalidadCalculoDeDepreciacion'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={fIsSubmitting}
                  checked={iValue === ModalidadCalculosDeDepreciacionConstant._CLASE9_CC}
                  id='radio-_6A9_9A6'
                  label={
                    ModalidadCalculosDeDepreciacionConstant.__dictionary[
                      ModalidadCalculosDeDepreciacionConstant._CLASE9_CC
                    ].nombre
                  }
                  value={
                    ModalidadCalculosDeDepreciacionConstant.__dictionary[
                      ModalidadCalculosDeDepreciacionConstant._CLASE9_CC
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={12}>
            <Field name='modalidadCalculoDeDepreciacion'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={fIsSubmitting}
                  checked={iValue === ModalidadCalculosDeDepreciacionConstant._6A8_DIST}
                  id='radio-_6A8_DIST'
                  label={
                    ModalidadCalculosDeDepreciacionConstant.__dictionary[
                      ModalidadCalculosDeDepreciacionConstant._6A8_DIST
                    ].nombre
                  }
                  value={
                    ModalidadCalculosDeDepreciacionConstant.__dictionary[
                      ModalidadCalculosDeDepreciacionConstant._6A8_DIST
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={12}>
            <Field name='modalidadCalculoDeDepreciacion'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={fIsSubmitting}
                  checked={iValue === ModalidadCalculosDeDepreciacionConstant.CLASE9}
                  id='radio-Clase9'
                  label={
                    ModalidadCalculosDeDepreciacionConstant.__dictionary[
                      ModalidadCalculosDeDepreciacionConstant.CLASE9
                    ].nombre
                  }
                  value={
                    ModalidadCalculosDeDepreciacionConstant.__dictionary[
                      ModalidadCalculosDeDepreciacionConstant.CLASE9
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
        </Row>
      </Col>
    </Form.Group>
  )
}

export default React.memo(ModalidadCalculoDeDepreciacionFormGroup)
